module.exports = __webpack_public_path__ + "img/clover-yellow.6c5d21a8.png";